import React from 'react';
import styled from 'styled-components'
const CampaignImage = styled.img`
width: 100%;
height: auto;
`
const CampaignCardWrapper = styled.div`
margin: 1vw;
`
const CampaignCard = (campaign) => {
  return (
    <CampaignCardWrapper>
      <a href={campaign.url}>
      <CampaignImage src={campaign.imageUrl} onLoad={() => {window.dispatchEvent(new Event('resize'));}} alt={campaign.imageTitle}/>
      </a>
    </CampaignCardWrapper>
  );
};

export default CampaignCard;


// WEBPACK FOOTER //
// ./src/components/Campaign/CampaignCard.js